module.exports = __webpack_public_path__ + "static/media/icons.b87b9ba5.ttf";